import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { Subscription, timer } from 'rxjs';
import { AuthenticationService, UserService } from 'src/app/_services';
import { phoneNumberValidator } from 'lac-mat-tel-input';
import { take } from 'rxjs/operators';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { MatDialog } from '@angular/material/dialog';
import { countries } from 'src/app/util/enums/countries.enum';

declare var $: any;
@Component({
  selector: 'telio-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit, OnDestroy {
  createUser: UntypedFormGroup;
  otpForm: UntypedFormGroup;
  userSubscription = new Subscription()
  otpDetails;
  cookieDetails;
  platform = "OFF-APP";
  enableResend = false;
  textOnly: RegExp = /^[a-zA-Z]+$/;
  textWithNumbers:RegExp=/^[a-zA-Z0-9]+$/;
  mobileNumber: RegExp = /^[6-9]\d{9}$/gi;
  emailRegEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@,"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  otpRegEx: RegExp = /^[0-9]{6}$/;
  countries = ['us', 'in', 'np','rw'];
  numberAllow: string;
  otpMessage;
  countDown: Subscription;
  clock = 0;
  tick = 1000;
  numbers: RegExp = /^[0-9]*$/;
  selectedcountry;
  country;
  state;
  city;
  stateList = [];
  cityList = [];
  countryList: any = [];
  countryValue = 'country'
  countryDisplayValue = 'country_description'
  stateValue = 'iso2';
  stateDisplayValue = 'name';
  cityValue = 'name';
  cityDisplayValue = 'name';
  isEdit = false;
  subscription: Subscription = new Subscription;
  userDetails: any;
  userId;
  defaultCountryData = {
    "country": "IN",
    "country_description": "India",
  };
  prefCountry = '';
  prefCountryMobile=[];
  checkedBeforeSubmit= false;
  title;
  countrySubscription: Subscription = new Subscription;;
  tempEmailKey;
  emailValidated = false;
  stateId;
  @Input() listedCountries;
  gstVisibilityValidator = false;
  stateLabel: string = 'createCpo.state';
  cityLabel: string = 'createCpo.city';

  @ViewChild('callOtpDialog', { static: false }) callOtpDialog: TemplateRef<any>;
  constructor(private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    readonly translate: TranslateService,
    private toastr: SnackbarService,
    private userInfoService: UserInfoService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.userInfoService.userDetails.prefCountry === 'LK' ? (this.stateLabel = 'createCpo.province') : (this.stateLabel = 'createCpo.state');
    this.userInfoService.userDetails.prefCountry === 'LK' ? (this.cityLabel = 'createCpo.district') : (this.cityLabel = 'createCpo.city');
    this.title = !!this.userInfoService.userDetails.appTitle ? this.userInfoService.userDetails.appTitle : 'TELIOEV'
    this.userInfoService.userDetails.prefCountry === 'IN' ? (this.gstVisibilityValidator = true) : (this.gstVisibilityValidator = false);
    this.route.queryParams.subscribe(params => {
      if (params['editUserData']) {
        this.userDetails = JSON.parse(params['editUserData']);
        this.isEdit = params['isEdit'];
        this.listedCountries = params['listedCountries'];
        this.userId = this.userDetails.user_id;
        this.emailValidated = this.userDetails.email_validated;
      }
      else{
        this.listedCountries = params['listedCountries'];
      }
    });
    this.countryList = this.userInfoService.countryList;
    this.prefCountry = !!this.userInfoService.userDetails.prefCountry ? this.userInfoService.userDetails.prefCountry : this.defaultCountryData.country
    this.prefCountryMobile = [this.prefCountry.toLowerCase()];
    this.getDefaultCountryData();
    this.cookieDetails = this.userInfoService.userDetails;
    this.createUser = this.formBuilder.group({
      firstName: [this.userDetails ? this.splitName(this.userDetails.username).firstName : null, Validators.compose([
        Validators.required,
        Validators.pattern(this.textWithNumbers)
      ])],
      lastName: [this.userDetails ? this.splitName(this.userDetails.username).lastName : null, Validators.compose([
        Validators.required,
        Validators.pattern(this.textWithNumbers)
      ])],
      mobile: [ this.userDetails ? this.userDetails.countryCode + ' ' + this.userDetails.mobile : null, Validators.compose([Validators.required,
        phoneNumberValidator
      ])],
      email: [{value :this.userDetails ? (this.userDetails.emailValidated? this.userDetails.email : this.userDetails.tempEmail): null, disabled:this.emailValidated}, Validators.pattern(this.emailRegEX)],
      country: [this.userDetails ? this.getCountryName(this.userDetails.country) : ''],
      state: [this.userDetails ? this.getStateName(this.userDetails.state): ''],
      city: [this.userDetails ? this.userDetails.city : ''],
      pincode: [this.userDetails ? this.userDetails.pincode : '', [Validators.pattern(this.numbers)]],
      location: [this.userDetails ? this.userDetails.address1 : ''],
      address2: [this.userDetails ? this.userDetails.address2 : ''],
      GSTNumber: [this.userDetails ? this.userDetails.gstNumber : ''],
    });
    this.createUser.get('country').valueChanges.subscribe((countryValue) => {
      if (!countryValue) {
        this.createUser.get('state').setValue('');
        this.userDetails && (this.userDetails.state = '')
        this.createUser.get('city').setValue('');
        this.userDetails && (this.userDetails.city = '')
      }
    });

    this.createUser.get('state').valueChanges.subscribe((stateValue) => {
      if (!stateValue) {
        this.createUser.get('city').setValue('');
        this.userDetails && (this.userDetails.city = '')
      }
    });
    
    this.createUser.get('state').valueChanges.subscribe((stateValue) => {
      if (!stateValue) {
        this.createUser.get('city').setValue('');
        this.cityList=[]
        this.userDetails && (this.userDetails.city = '')
      }
    })
    if (this.userDetails && this.userDetails.country){
      this.getStates(this.userDetails.country);
      if (this.userDetails && this.userDetails.country && this.userDetails.state){
        this.getCities(this.userDetails.state);
      }
    }
      if (this.userDetails) {
        this.createUser.get('mobile').disable();
      }
    this.otpForm = this.formBuilder.group({
      otp: [null, Validators.compose([
        Validators.required,
        Validators.pattern(this.otpRegEx)
      ])]
    })
  }

  isEmailValid(): boolean {
    const emailControl = this.createUser.get('email');
    return emailControl.value && !emailControl.hasError('pattern');
  }

  resetmethod(createUser, formDirective) {
    this.createUser.reset()
  }
  fullName(fName, lName) {
    return fName + ' ' + lName
  }

  getDefaultCountryData() {
    this.defaultCountryData = this.countryList.find(country => country.country === this.prefCountry);
    return this.defaultCountryData;
}
  onSubmit() {
    // this.isEdit ? this.createUser.get('mobile').setValue(this.userDetails.countryCode + ' ' + this.userDetails.mobile) : '';
    let mobileNumber = this.createUser.get('mobile').value;
    let countrycode = mobileNumber ? mobileNumber.split(' ')[0] : null;
    let rawValue = this.createUser.getRawValue();
    let input: {
      username: string;
      country_code: any;
      mobile: any;
      temp_email?: any;
      platform?: string;
      city?: any;
      state?: any;
      country?: any;
      pincode?: any;
      address2?: any;
      address1?: any;
      gst_number?: any;
    } = {
      'username': this.fullName(this.createUser.value.firstName, this.createUser.value.lastName),
      'country_code': countrycode,
      'mobile': (this.isEdit && (this.userDetails.country = 'IN')) ? this.removeLeadingZero(rawValue.mobile.replace(countrycode + ' ', '').replace(/[.*\-?^${}()|[\]\\]/g, '').replace(/ /g, '')) : this.createUser.value.mobile.replace(countrycode + ' ', '').replace(/[.*\-?^${}()|[\]\\]/g, '').replace(/ /g, ''),
      'temp_email': this.createUser.value.email ? this.createUser.value.email : "",
      'platform': this.platform,
      "city": this.city,
      "state":this.authService.normalizeState(this.state),
      "country": this.country,
      "pincode": this.createUser.value.pincode,
      "address2": this.createUser.value.address2,
      "address1": this.createUser.value.location,
      "gst_number": this.createUser.value.GSTNumber,
    };
    
    // Filter out keys with null, undefined, or empty string values
    input = Object.keys(input).reduce((filteredInput, key) => {
      const value = input[key];
      if (value !== null && value !== undefined && value !== '') {
        filteredInput[key] = value;
      }
      return filteredInput;
    }, {} as typeof input);

    if (!this.isEdit) {
      this.userSubscription.add(this.userService.createUser(input).subscribe
        ((resp: any) => {
          switch (resp.status_code) {
            case 409:
              this.toastr.error(resp.status_message)
              break
            case 400:
              this.toastr.error(resp.status_message)
              break
            default:
              this.otpDetails = resp
              this.toastr.success(resp.status_message)
              this.otpMessage = this.translate.instant('mobileUsers.otpMessage')
              this.openOtpDailog()
              this.resendTimeout()
              this.resendTimer()
              break
          }
        }))
      error => {
        this.toastr.error(error.message);
      }
    }
    else {
      let editInput = { ...input, 'user_id': this.userId };
      if(this.emailValidated){
      // editInput['email']= this.userDetails.email;
      editInput['email']=this.createUser.get('email').value
      }
      this.userSubscription.add(this.userService.editUser(editInput).subscribe
        ((resp: any) => {
          switch (resp.status_code) {
            case 409:
              this.toastr.error(resp.status_message)
              break
            case 400:
              this.toastr.error(resp.status_message)
              break
            default:
              this.toastr.success(resp.status_message)
              this.back()
              break
          }
        }))
      error => {
        this.toastr.error(error.message);
      }
    }
  }

  removeLeadingZero(mobile: string): string {
    if (mobile.startsWith('0')) {
      return mobile.substring(1);
    }
    return mobile;
  }

  submitOTP() {
    let id =  this.isEdit ? this.userId : this.otpDetails[0].user_id
    let otp = this.otpForm.value.otp;
    let key = this.isEdit ? this.tempEmailKey : this.otpDetails[0].mobile
    this.userSubscription.add(this.userService.otpValidation(id, otp, key).subscribe(resp => {
      switch (resp.status_code) {
        case 3000:
          this.toastr.error(resp.status_message);
          break
        case 1000:
          this.dialog.closeAll();
          this.toastr.success(resp.status_message)
          !this.isEdit ? this.back() : null ;
          this.emailValidated= true;
          this.createUser.get('email').disable();
          break
      }
    },
      error => {
        this.toastr.error(error.message)
      }
    ))

  }
  resendOTP() {
    this.enableResend = false;
    let id = this.otpDetails[0].user_id;
    let key = this.otpDetails[0].mobile;
    let role = this.cookieDetails.roles[0]
    this.userSubscription.add(this.userService.resendOtp(id, key, role, this.platform).subscribe(resp => {
      if (!!resp) {
        this.toastr.success(resp.status_message)
        this.resendTimeout()
        this.resendTimer()
      }
      else {
        this.toastr.error(resp.status_message)
      }

    },
      error => {
        this.toastr.error(error.message)
      }
    ))
  }
  resendTimeout() {
    setTimeout(() => {
      this.enableResend = true
    }, 120000);
  }

  resendTimer() {
    this.clock = 120;
    this.countDown = timer(0, this.tick)
      .pipe(take(this.clock))
      .subscribe(() => {
        --this.clock;
        if (this.clock == 0) {
          this.countDown.unsubscribe();
        }
      });
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  openOtpDailog() {
    this.otpForm.reset();
    let dialogRef = this.dialog.open(this.callOtpDialog, {
      height: '500px',
      width: '500px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  mobileValidation(event) {
    const cntryCode = this.createUser.get('countryCode').value
    this.mobileNumber = (cntryCode == '+91') ? /^[6-9]\d{9}$/gi : /^[0-9]\d{9}$/gi;
    this.createUser.controls.mobile.setValidators(Validators.compose([Validators.required, Validators.pattern(this.mobileNumber)]))
    this.createUser.controls.mobile.updateValueAndValidity();
  }

  // allow only numbers 
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      this.numberAllow = "* only numbers allow";
      return false;
    }
    this.numberAllow = "";
    return true;
  }

  getStates(event) {
    this.country = event;
    this.cityList = [];
    if (this.country === countries.NEPAL) {
      this.userService.getStateForNepal().subscribe((res: any) => this.handleStateResponse(res))
    }
    else if (this.country === countries.SRILANKA) {
      this.userService.getStateForSriLanka().subscribe((res: any) => this.handleStateResponse(res))
    }
    else {
      this.userService.getStates(this.country).subscribe((res: any) => this.handleStateResponse(res));
    }
  }

  handleStateResponse(res: any) {
    if (!!res) {
      this.stateList = res;
      if (this.userDetails && this.userDetails.country && this.userDetails.state) {
        const normalizedState = this.authService.reverseNormalizeState(this.userDetails.state)
        this.createUser.controls['state'].setValue(this.userDetails ? this.getStateName(normalizedState) : null);
        this.createUser.controls['state'].updateValueAndValidity();
      }
    }
  }

  getCities(event) {
    this.state = this.authService.reverseNormalizeState(event)
    if (this.country === countries.NEPAL) {
      let stateObj = this.stateList.find(res => res.iso2 === event)
      this.stateId = stateObj.iso2
      this.userService.getCitiesForNepal(this.stateId).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.userDetails && this.userDetails.country && this.userDetails.state && this.userDetails.city) {
            this.createUser.controls['city'].setValue(this.userDetails ? this.userDetails.city : null);
            this.createUser.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
    if (this.country === countries.SRILANKA) {
      let stateObj = this.stateList.find(res => res.iso2 === event)
      this.stateId = stateObj.iso2
      this.userService.getCitiesForSriLanka(this.stateId).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.userDetails && this.userDetails.country && this.userDetails.state && this.userDetails.city) {
            this.createUser.controls['city'].setValue(this.userDetails ? this.userDetails.city : null);
            this.createUser.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
    else {
      this.userService.getCities(this.country, this.state).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.userDetails && this.userDetails.country && this.userDetails.state && this.userDetails.city) {
            this.createUser.controls['city'].setValue(this.userDetails ? this.userDetails.city : null);
            this.createUser.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
  }

  setCity(event) {
    this.city = event;
  }

  back() {
    this.router.navigate(["/dashboard/mobile-users", { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }

  splitName(username: string): { firstName: string, lastName: string } {
    const parts = username.split(' ');
    const firstName = parts[0];
    const lastName = parts.slice(1).join(' ');
    return { firstName, lastName };
  }
  
  getCountryName(country) {
    let countryObj = this.countryList.find(res => res.country === country)
    return !!countryObj ? countryObj.country_description : ''
  }
  getStateName(state) {
    let stateObj = this.stateList.find(res => res.iso2 === this.authService.reverseNormalizeState(state))
    return !!stateObj ? stateObj.name : ''
  }

  checkBoxStatus(event) {
    return this.checkedBeforeSubmit = event.checked;
  }

  ngOnDestroy() {
    this.userSubscription && this.userSubscription.unsubscribe();
    this.countrySubscription && this.countrySubscription.unsubscribe();
  }

  formValidate(): boolean {
    return this.userInfoService.userDetails.prefCountry === 'IN'? (this.createUser.valid && this.checkedBeforeSubmit) : (this.createUser.valid);
  }

  emailVerification() {
    if(this.emailValidated){
      return null
    } else {
    this.otpMessage = this.translate.instant('mobileUsers.emailMessage');
    this.tempEmailKey = this.createUser.get('email').value ;
    this.sendOtp();
    }
  }

  sendOtp() {
    this.userSubscription.add(this.userService.getEmailOtp(this.userId, this.tempEmailKey).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.otpMessage);
        this.openOtpDailog();
        this.resendTimeout();
        this.resendTimer();
      }
    },
      error => {
        this.toastr.error(error)
      }
    ))
  }

  resend() {
    this.isEdit ? this.resendEmailOtp() : this.resendOTP()
  }

  resendEmailOtp() {
    this.enableResend = false;
    this.userSubscription.add(this.userService.getEmailOtp(this.userId, this.tempEmailKey).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.otpMessage);
        this.resendTimeout();
        this.resendTimer();
      }
    },
      error => {
        this.toastr.error(error)
      }
    ))
  }

}
